<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("global") }} {{ $t("options") }}1
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div
          :class="
            global.go_id == 7
              ? 'col-lg-12 col-xl-12 mb-4'
              : global.go_id == 13
              ? 'col-0 mb-4'
              : global.go_id == 14
              ? 'col-0 mb-4'
              : global.go_id == 26
              ? 'col-0 mb-4'
              : global.go_id == 27
              ? 'col-lg-4 mb-4'
              : 'col-lg-4 mb-4'
          "
          :key="globalListIndex"
          v-for="(global, globalListIndex) in globalList"
        >
          <div
            v-if="
              global.go_id == 3 ||
                global.go_id == 4 ||
                global.go_id == 5 ||
                global.go_id == 6 ||
                global.go_id == 20 ||
                global.go_id == 32 ||
                global.go_id == 33 ||
                global.go_id == 34 ||
                global.go_id == 35 ||
                global.go_id == 36 ||
                global.go_id == 37 ||
                global.go_id == 38 ||
                global.go_id == 39 ||
                global.go_id == 40 ||
                global.go_id == 27 ||
                global.go_key === `SMS_LIMIT` ||
                global.go_key === `EMAIL_LIMIT` ||
                global.go_key == 'CURR_FORMAT' ||
                global.go_key == 'MARKETING_SERVICE' ||
                global.go_key == 'SELECT_SEAT_COUNT_POPUP' ||
                global.go_key == 'POS_FINAL_PAGE_STANDBY_TIME_IN_MINS' ||
                global.go_key == 'DEFAULT_COMMUNICATION_EMAIL' ||
                global.go_key == 'CONTACT_FORM_EMAIL_TO' ||
                global.go_key == 'CONTACT_FORM_EMAIL_CC' ||
                global.go_key == 'AUTO_SCAN_TICKET_TIME_IN_MIN'
            "
          >
            <div class="input-material">
              <input
                v-model="global.go_value"
                v-validate="'required'"
                placeholder="."
                type="text"
                name="subject"
                id="subject"
              />
              <label v-if="global.go_id != 14">{{ global.key_name }} {{global.go_key == 'DEFAULT_COMMUNICATION_EMAIL' ? '(comma seprated)' : ''}}</label>
            </div>
            <p v-if="submitted && errors.has('subject')" class="error_message">
              <span>{{ errors.first("subject") }}</span>
            </p>
          </div>
          <div
            v-if="
              global.go_id == 1 ||
                global.go_id == 2 ||
                global.go_id == 12 ||
                global.go_id == 19 ||
                global.go_id == 21
            "
          >
            <div class="input-material">
              <input
                type="text"
                placeholder="."
                v-model="global.go_value"
                disabled
              />
              <label>{{ global.key_name }}</label>
            </div>
          </div>

          <div
            v-if="
              global.go_id == 15 ||
                global.go_id == 16 ||
                global.go_id == 17 ||
                global.go_id == 18 ||
                global.go_id == 22 ||
                global.go_id == 23 ||
                global.go_id == 24 ||
                global.go_id == 25 ||
                global.go_key == 'RECCO_ITEM_STOCK_TAKE' ||
                global.go_key == 'POS_CUSTOMER_POPUP' ||
                global.go_key == 'MYCINEMA_STATUS' ||
                global.go_key == 'TEST_SETUP' ||
                global.go_key == 'SHOW_PRINT_RECEIPT_BTN_POS' ||
                global.go_key == 'SHOW_POS_SEND_SMS_SECTION' ||
                global.go_key == '24_HRS_FORMAT' ||
                global.go_key == 'POS_INPUT_CASH_VALIDATION' ||
                global.go_key == 'ENTRY_ID_REQUIRED_QRAPP' ||
                global.go_key == 'MANAGER_AUTH_REQURIED_FOR_CHANGES' ||
                global.go_key == 'MANAGER_AUTH_REQURIED_FOR_REPRINT' ||
                global.go_key == 'SHOW_VEG_NONVEG_lOGO' ||
                global.go_key == 'AUTO_CREATE_MOVIE_VERSIONS' ||
                global.go_key == 'CHANGE_VERSION_IN_SCHEDULE' ||
                global.go_key == 'AUTO_SCAN_TICKETS_AFTER_SHOW_STARTS' ||
                global.go_key == 'EARN_LOYALITY_POINTS_ONLY_IF_SUBSCRIBE' ||
                global.go_key == 'OPEN_APPLICABLE_OFFER_POPUP' ||
                global.go_key == 'USE_TIM_INTEGRATION' ||
                global.go_key == 'KITCHEN_DISPLAY_AVAILABLE' ||
                global.go_key == 'DELIVER_ITEM_FROM_POS_PICKUP' ||
                global.go_key == 'USE_NEOLEAP_POS_PAYMENT' ||
                global.go_key == 'DIRECT_DELIVER_READY_TO_SERVE_ITEMS' ||
                global.go_key == 'OFFER_APPLIED_ON_TRANSACTION_DATE' ||
                global.go_key == 'ALLOW_CINEMA_SPECIFIC_SWAP_ONLY' ||
                global.go_key == 'ALLOW_CINEMA_SPECIFIC_REFUND_ONLY'
            "
          >
            <div class="d-flex align-items-center">
              <b-form-checkbox
                v-model="global.go_value"
                value="Y"
                unchecked-value="N"
                name="check-button"
                switch
              ></b-form-checkbox>
              <div class="px-3 small">{{ global.key_name }}</div>
            </div>
          </div>

          <div
            v-if="
              global.go_id == 7 ||
                global.go_id == 8 ||
                global.go_id == 9 ||
                global.go_id == 10 ||
                global.go_id == 11 ||
                global.go_id == 31 ||
                global.go_id == 30 ||
                global.go_key == 'DEFAULT_COMMUNICATION_LANGUAGE' ||
                global.go_key == 'DEFAULT_SELECTED_FOOD_CATEGORY_POS' ||
                global.go_key == 'START_DAY' ||
                global.go_key == 'ENABLE_COVID_SEAT_LAYOUT' ||
                global.go_key == 'MIN_FRACTION_DIGITS'
            "
          >
            <div v-if="global.go_id == 8">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="app_language"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(language, languageIndex) in ActiveLanguages"
                    :key="languageIndex"
                    v-on:click="OnSelect('lang', language, globalListIndex)"
                    >{{ language.lang_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div v-if="global.go_id == 9">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="operation_country"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(country, countryIndex) in ActiveCountries"
                    :key="countryIndex"
                    v-on:click="OnSelect('country', country, globalListIndex)"
                    >{{ country.country_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div v-if="global.go_id == 10">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="currency_name"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(currency, currencyIndex) in ActiveCurrencies"
                    :key="currencyIndex"
                    v-on:click="OnSelect('currency', currency, globalListIndex)"
                    >{{ currency.curr_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div v-if="global.go_id == 11">
              <div class="dropdown-curve-container">
                <label :class="global.key_name.length > 0 ? 'shift-up' : ''">{{
                  global.key_name
                }}</label>
                <b-dropdown
                  variant="dropdown-curve"
                  class="w-100"
                  :text="concession_name"
                >
                  <b-dropdown-item
                    href="#"
                    v-for="(concession, concessionIndex) in ActiveConcessions"
                    :key="concessionIndex"
                    v-on:click="
                      OnSelect('concession', concession, globalListIndex)
                    "
                    >{{ concession.cl_name }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </div>

            <div class="row pt-4 border-top" v-if="global.go_id == 7">
              <div class="col-12 pb-3 align-self-center">
                <label class="mb-0 font-weight-semi-bold">{{
                  global.key_name
                }}</label>
              </div>
              <div class="col-3">
                <div class="dropdown-curve-container">
                  <label class="shift-up">Select Country</label>
                  <b-dropdown
                    variant="dropdown-curve"
                    class="w-100"
                    :text="content_country.country_name"
                  >
                    <b-dropdown-item
                      href="#"
                      v-for="(country, countryIndex) in ActiveCountries"
                      :key="countryIndex"
                      v-on:click="OnSelect('country', country, globalListIndex)"
                      >{{ country.country_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
              <div class="col-9" v-if="global.go_id == 7">
                <div class="dropdown-curve-container">
                  <label class="shift-up mt-n1">Select Languages</label>
                  <multiselect
                    :options="ActiveLanguages"
                    v-model="content_language"
                    :searchable="true"
                    label="lang_name"
                    track-by="lang_id"
                    placeholder="Select Language"
                    :allowEmpty="false"
                    :showLabels="false"
                    :multiple="true"
                  ></multiselect>
                </div>
              </div>
            </div>

            <div class="row" v-if="global.go_id == 30">
              <div class="col-12" v-if="global.go_id == 30">
                <span class="small-text ml-4">Kiosk Languages</span>
                <multiselect
                  :options="ActiveLanguages"
                  v-model="selectedLanguages"
                  :searchable="true"
                  label="lang_name"
                  track-by="lang_id"
                  placeholder="Select Languages"
                  :allowEmpty="false"
                  :showLabels="false"
                  :multiple="true"
                />
              </div>
            </div>

            <div class="row" v-if="global.go_key == 'START_DAY'">
              <div class="col-12" v-if="global.go_key == 'START_DAY'">
                <span class="small-text ml-4">{{ global.key_name }}</span>
                <multiselect
                  :options="Days"
                  v-model="selected_day"
                  label="day"
                  track-by="id"
                  placeholder="Select Start Day"
                  :allowEmpty="false"
                  :showLabels="false"
                  :multiple="false"
                  @select="onSelectDay($event)"
                />
              </div>
            </div>

            <div class="row" v-if="global.go_key == 'DEFAULT_SELECTED_FOOD_CATEGORY_POS'">
              <div class="col-12" v-if="global.go_key == 'DEFAULT_SELECTED_FOOD_CATEGORY_POS'">
                <span class="small-text ml-4">{{ global.key_name }}</span>
                <multiselect
                  :options="foodCategories"
                  v-model="selected_fc"
                  label="fc_category"
                  track-by="fc_id"
                  placeholder="POS Default Food Category"
                  :showLabels="false"
                  :multiple="false"
                  @select="onSelectFcCategory($event)"
                />
              </div>
            </div>

            <div
              class="row"
              v-if="global.go_key == 'DEFAULT_COMMUNICATION_LANGUAGE'"
            >
              <div
                class="col-12"
                v-if="global.go_key == 'DEFAULT_COMMUNICATION_LANGUAGE'"
              >
                <span class="small-text ml-4"
                  >Default Communication Language</span
                >
                <multiselect
                  :options="ActiveLanguages"
                  v-model="defaultUserLanguage"
                  :searchable="true"
                  label="lang_name"
                  track-by="lang_id"
                  placeholder="Select Languages"
                  :allowEmpty="false"
                  :showLabels="false"
                  :multiple="false"
                />
              </div>
            </div>

            <div v-if="global.go_key == 'ENABLE_COVID_SEAT_LAYOUT'">
              <div class="d-flex align-items-center">
                <b-form-checkbox
                  v-model="global.go_value"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                  switch
                ></b-form-checkbox>
                <div class="px-3 small">Enable Covid Seat Layout</div>
              </div>
            </div>

            <div
              class="input-material"
              v-if="global.go_key == 'MIN_FRACTION_DIGITS'"
            >
              <input
                v-model="global.go_value"
                v-validate="'required'"
                placeholder="."
                type="number"
                name="subject"
                id="subject"
              />
              <label>{{ global.key_name }}</label>
            </div>

            <!-- <div class="row pt-4 border-top" v-if="global.go_id == 31">
              <div class="col-6">
                <multiselect
                  :options="Cinemas"
                  v-model="selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Select Cinema"
                  :allowEmpty="false"
                  :showLabels="false"
                  @select="onSelectCinema($event)"
                />
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 mb-4 text-center">
        <button
          :disabled="btenable"
          @click.prevent.stop="onFinalSubmit()"
          class="btn-blue"
        >
          {{ $t("update") }}</button
        >&nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import MasterService from "@/services/MasterService";
import _ from "lodash";

export default {
  data() {
    return {
      btenable: false,
      globalList: [],
      submitted: false,
      ActiveCountries: [],
      selectedCountry: "",
      operation_country: "",
      ActiveLanguages: [],
      content_language: [],
      content_country: {},
      app_language: "",
      ActiveCurrencies: [],
      currency_name: "",
      ActiveConcessions: [],
      Cinemas: [],
      foodCategories: [],
      concession_name: "",
      globalListCopy: [],
      selectedCinema: null,
      selectedLanguages: null,
      defaultUserLanguage: null,
      kioks_temp_language_array: [],
      Days: [
        { id: 1, day: "Monday" },
        { id: 2, day: "Tuesday" },
        { id: 3, day: "Wednesday" },
        { id: 4, day: "Thursday" },
        { id: 5, day: "Friday" },
        { id: 6, day: "Saturday" },
        { id: 7, day: "Sunday" }
      ],
      selected_day: "",
      start_day: "",
      selected_fc: '',
      dflt_fc_if: null
    };
  },
  beforeMount() {
    let roleid = this.secureStore.get("USINFO").role_id;

    if (roleid != 1) {
      this.$router.go(-1);
    } else {
      this.getGlobalOptions();
    }
  },
  methods: {
    onSelectCinema(cinema) {
      this.selectedCinema = cinema.cine_name;
      this.$forceUpdate();
    },
    onSelectDay(Day) {
      this.selected_day = Day;
      this.start_day = Day.day;
    },
    onSelectFcCategory(fc) {
      this.selected_fc = fc;
      this.dflt_fc_if = fc.fc_id;
    },
    getGlobalOptions: function() {
      let loader = this.$loading.show();

      MasterService.GetGlobalOptions()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.globalList = data.Records.filter(x => {
            //   return (
            //     x.go_id != 2 && x.go_id != 12 && x.go_id != 14 && x.go_id != 19
            //   );
            // });
            this.globalList = data.Records;
            // const arr_copy = [...data.Records]
            this.globalListCopy = JSON.parse(JSON.stringify(this.globalList));
            this.globalList.map(x => {
              if (x.go_id == 9) {
                this.getActiveCountries(x.go_value, 2);
              }
              if (x.go_id == 7) {
                let obj = JSON.parse(x.go_value);
                console.log("obj :>> ", obj);
                this.getActiveCountries(obj[0].country_id, 1);
                this.getActiveLanguages(obj[0].lang_id, 1);
              }
              if (x.go_id == 8) {
                this.getActiveLanguages(x.go_value, 2);
              }
              if (x.go_id == 10) {
                this.getActiveCurrencies(x.go_value);
              }
              if (x.go_id == 11) {
                this.getActiveConcessions(x.go_value);
              }
              // if (x.go_id == 31) {
              //   this.getCinemaList();
              //   this.selectedCinema = JSON.parse(x.go_value);
              // }
              if (x.go_id == 30) {
                let kioskLanguages = JSON.parse(x.go_value) || [];
                this.kioks_temp_language_array = kioskLanguages.length > 0 ? kioskLanguages.map((x) => x.lang_id) : [];
              }

              if (x.go_key == "START_DAY") {
                this.selected_day = this.Days.filter(y => {
                  return y.day == x.go_value;
                });
              }

              if (x.go_key == "DEFAULT_SELECTED_FOOD_CATEGORY_POS") {
                this.getFoodCategoiresList(x.go_value)
              }

              if (x.go_key === "DEFAULT_COMMUNICATION_LANGUAGE") {
                try {
                  let obj = JSON.parse(x.go_value);
                  this.defaultUserLanguage = {
                    lang_id: obj.lang_id,
                    lang_name: obj.lang_name
                  };
                } catch (err) {
                  console.log(err);
                }
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },
    // async getCinemaList(cine_id) {
    //   try {
    //     const { data } = await MasterService.GetCinemas({ cine_id });
    //     if (data && data.status && data.Records.length > 0) {
    //       this.Cinemas = data.Records;
    //       this.Cinemas.map(x => {
    //         if (String(cine_id) === String(x.cine_id)) {
    //           // this.selectedCinema = x.cine_name;
    //           this.onSelectCinema(null, {
    //             cine_name: x.cine_name,
    //             cine_id: x.cine_id
    //           });
    //         }
    //       });
    //     } else {
    //       this.$toasted.show(
    //         data.message ||
    //           "Sorry! Something went wrong. kindly contact your administrator"
    //       );
    //     }
    //   } catch (error) {
    //     this._CatchError;
    //   }
    // },
    getFoodCategoiresList: function(fc_id) {
      let payload = {
        tableName: "ms_food_categories",
        fc_is_active: "Y"
      };
      MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.foodCategories = data.Records.filter((x) => x.fc_parent_id == 0);
            if(fc_id) {
              let obj = this.foodCategories.find((z) => z.fc_id == fc_id)
              if(obj) {
                this.onSelectFcCategory(obj)
              }
            }
          } else {
            console.log("message", data.message);
            // this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          console.log('Error:', error);
        });
    },
    getActiveCurrencies(curr_id) {
      let body = {
        tableName: "ms_currencies",
        curr_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveCurrencies = data.Records;
              this.ActiveCurrencies.map(x => {
                if (String(curr_id) === String(x.curr_id)) {
                  this.currency_name = x.curr_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveConcessions(cl_id) {
      let body = {
        tableName: "ms_concession_levels",
        cl_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveConcessions = data.Records;
              this.ActiveConcessions.map(x => {
                if (String(cl_id) === String(x.cl_id)) {
                  this.concession_name = x.cl_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveCountries(country_id, flag) {
      let body = {
        tableName: "ms_countries",
        country_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.ActiveCountries = data.Records;
              console.log("this.ActiveCountries :>> ", this.ActiveCountries);
              this.ActiveCountries.map(x => {
                if (String(country_id) === String(x.country_id) && flag == 2) {
                  this.operation_country = x.country_name;
                } else if (
                  String(country_id) === String(x.country_id) &&
                  flag == 1
                ) {
                  this.content_country = x;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    getActiveLanguages(lang_id, flag) {
      let body = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      MasterService.GetActiveList(body)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              // this.ActiveLanguages = data.Records;
              this.ActiveLanguages = _.sortBy(data.Records, 'order');
              if(this.kioks_temp_language_array.length > 0) {
                this.selectedLanguages = this.ActiveLanguages.filter(item => this.kioks_temp_language_array.includes(item.lang_id));
                this.selectedLanguages = _.sortBy(this.selectedLanguages, 'order');
              }
              console.log("this.ActiveLanguages :>> ", this.ActiveLanguages);
              this.ActiveLanguages.map(x => {
                if (flag == 1) {
                  lang_id.map(y => {
                    if (String(y) === String(x.lang_id)) {
                      this.content_language.push(x);
                    }
                  });
                } else if (String(lang_id) === String(x.lang_id) && flag == 2) {
                  this.app_language = x.lang_name;
                }
              });
            }
          } else
            this.$toasted.show(data.message || "Opps! Something went wrong");
        })
        .catch(this._CatchError);
    },
    onFinalSubmit: function() {
      let finalObj = [];
      this.content_language = _.sortBy(this.content_language, 'order');
      let arr = [
        {
          country_id: this.content_country.country_id,
          lang_id: this.content_language.map(x => {
            return x.lang_id;
          })
        }
      ];
      let arr2 = JSON.stringify(arr);
      console.log("arr2 :>> ", arr2);
      this.globalList.map(x => {
        if (x.go_id == 7) {
          x.go_value = arr2;
        }
        // if (x.go_id == 31) {
        //   x.go_value = JSON.stringify(this.selectedCinema);
        // }
        if (x.go_id == 30) {
          this.selectedLanguages = _.sortBy(this.selectedLanguages, 'order')
          x.go_value = JSON.stringify(this.selectedLanguages);
        }

        if (x.go_key == "DEFAULT_COMMUNICATION_LANGUAGE") {
          x.go_value = this.defaultUserLanguage
            ? JSON.stringify({
                lang_id: this.defaultUserLanguage.lang_id,
                lang_name: this.defaultUserLanguage.lang_name
              })
            : "";
        }
        if (x.go_key == "START_DAY") {
          x.go_value = this.start_day ? this.start_day : "Monday";
        }

        if (x.go_key == "DEFAULT_SELECTED_FOOD_CATEGORY_POS") {
          x.go_value = this.dflt_fc_if ? this.dflt_fc_if : null;
        }
      });
      console.log("this.globalList :>> ", this.globalList);
      this.globalList.map((x, i) => {
        // console.log('x.go_value :>> ', x.go_value);
        // console.log('this.globalListCopy[i].go_value :>> ',this.globalListCopy[i].go_value);
        if (x.go_value != this.globalListCopy[i].go_value) {
          finalObj.push(x);
        }
      });
      console.log("finalObj :>> ", finalObj);

      let payload = {
        globalList: finalObj
      };
      MasterService.EditGlobalOptions(payload)
        .then(response => {
          const { data } = response;
          // loader.hide();
          if (data && data.status) {
            this.$toasted.show(data.message);
            this.$store.dispatch("fetchGlobalOptions");
            this.$router.push({
              path: "/home"
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    OnSelect(type, item, index) {
      if (type == "country" && this.globalList[index].go_id == 9) {
        this.operation_country = item.country_name;
        this.globalList[index].go_value = item.country_id;
        console.log(
          "this.globalList[index].go_value :>> ",
          this.globalList[index].go_value
        );
      } else if (type == "country" && this.globalList[index].go_id == 7) {
        this.content_country = item;
      } else if (type == "lang") {
        this.app_language = item.lang_name;
        this.globalList[index].go_value = item.lang_id;
      } else if (type == "concession") {
        this.concession_name = item.cl_name;
        this.globalList[index].go_value = item.cl_id;
        console.log("concession :>> ", this.globalList[index].go_value);
      } else if (type == "currency") {
        this.currency_name = item.curr_name;
        this.globalList[index].go_value = item.curr_id;
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GlobalOptionsComponents/globalOptions.vue